import React, { useState } from 'react';
import { Row, Col, Form } from 'reactstrap';
import { AuditData } from '../../types/types';
import FormInput from '../common/FormInput';
import AssociateLocationModal, { LocationData } from '../modals/AssociateLocationModal';

interface AuditProfileProps {
  auditData: AuditData;
  onLocationOwnerChange: (value: string) => void;
}

const AuditProfile: React.FC<AuditProfileProps> = ({ auditData, onLocationOwnerChange }) => {
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);

  const handleSearchClick = () => {
    setIsLocationModalOpen(true);
  };

  const handleLocationSelect = (location: LocationData) => {
    onLocationOwnerChange(location.storeName);
    setIsLocationModalOpen(false);
  };

  const handleLocationModalClose = () => {
    setIsLocationModalOpen(false);
  };

  return (
    <>
      <fieldset className="border p-2">
        <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Audit Profile</legend>
        <Form>
          <Row>
            <Col md={6}>
              <FormInput
                id="created"
                label="Created"
                value={auditData.created}
                readOnly
              />
            </Col>
            <Col md={6}>
              <FormInput
                id="createdBy"
                label="Created By"
                value={auditData.createdBy}
                readOnly
              />
            </Col>
            <Col md={6}>
              <FormInput
                id="lastUpdated"
                label="Last Updated"
                value={auditData.lastUpdated}
                readOnly
              />
            </Col>
            <Col md={6}>
              <FormInput
                id="lastUpdatedBy"
                label="Last Updated By"
                value={auditData.lastUpdatedBy}
                readOnly
              />
            </Col>
            <Col md={6}>
              <FormInput
                id="locationOwner"
                label="Location Owner"
                value={auditData.locationOwner}
                onChange={onLocationOwnerChange}
                hasSearchButton
                onSearchClick={handleSearchClick}
              />
            </Col>
          </Row>
        </Form>
      </fieldset>

      {/* Associate Location Modal */}
      <AssociateLocationModal
        isOpen={isLocationModalOpen}
        onClose={handleLocationModalClose}
        onSelect={handleLocationSelect}
      />
    </>
  );
};

export default AuditProfile; 